import React from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { Button } from 'onefaceui-react-components';
import { getResourceTo } from 'react/utils/utils';

/**
 * Button component that handles viewing stop details
 * Single responsibility: Provide the UI and logic for viewing a stop's details
 */
const ViewStopButton = ({ stopDetail, className, dataTestId }) => {
  const dispatch = useDispatch();

  const handleViewStopClick = () => {
    if (!stopDetail?.route?.id || !stopDetail?.id) {
      return;
    }
    
    dispatch(
      push(
        `/maps/route/${stopDetail.route.id}/details/stop/${stopDetail.id}`
      )
    );

    Monet.Session.RouteDetail.ShortStopDetailsModal = {
      stopId: stopDetail.id
    };

    if (Monet.Session.RouteDetail?.screensList?.[stopDetail.route.id]) {
      const stopSelection = new Greenmile.RouteDetail.StopSelection(
        stopDetail.route.id
      );
      stopSelection.selectOrDeselectStop(stopDetail.id);

      const { mapRouteDetail } =
        Monet.Session.RouteDetail.screensList[stopDetail.route.id];
      
      mapRouteDetail.focusOnTheStop(stopDetail);
    }
  };

  return (
    <Button
      dataTestId={dataTestId || "view-stop-button"}
      variant="primary"
      type="button"
      className={className}
      onClick={handleViewStopClick}
    >
      {getResourceTo('modal.stopdetails.view.stop.details')}
    </Button>
  );
};

ViewStopButton.propTypes = {
  stopDetail: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    route: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    }).isRequired
  }).isRequired,
  className: PropTypes.string,
  dataTestId: PropTypes.string
};

ViewStopButton.defaultProps = {
  className: '',
  dataTestId: 'view-stop-button'
};

export default ViewStopButton;
